/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { DeviceMeasurementErrorDto } from './DeviceMeasurementErrorDto';
import {
    DeviceMeasurementErrorDtoFromJSON,
    DeviceMeasurementErrorDtoFromJSONTyped,
    DeviceMeasurementErrorDtoToJSON,
} from './DeviceMeasurementErrorDto';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100DeviceMeasurementException
 */
export interface Ptw100DeviceMeasurementException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100DeviceMeasurementException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100DeviceMeasurementException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100DeviceMeasurementException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100DeviceMeasurementException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100DeviceMeasurementException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {DeviceMeasurementErrorDto}
     * @memberof Ptw100DeviceMeasurementException
     */
    error?: DeviceMeasurementErrorDto;
    /**
     * 
     * @type {string}
     * @memberof Ptw100DeviceMeasurementException
     */
    $type?: Ptw100DeviceMeasurementExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100DeviceMeasurementExceptionTypeEnum = {
    PtwPtw100AppZeroApplicationSharedExceptionsPtw100DeviceMeasurementExceptionPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100DeviceMeasurementException, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type Ptw100DeviceMeasurementExceptionTypeEnum = typeof Ptw100DeviceMeasurementExceptionTypeEnum[keyof typeof Ptw100DeviceMeasurementExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100DeviceMeasurementException interface.
 */
export function instanceOfPtw100DeviceMeasurementException(value?: unknown): value is Ptw100DeviceMeasurementException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100DeviceMeasurementExceptionTypeEnum)[0];
}

export function Ptw100DeviceMeasurementExceptionFromJSON(json: any): Ptw100DeviceMeasurementException {
    return Ptw100DeviceMeasurementExceptionFromJSONTyped(json, false);
}

export function Ptw100DeviceMeasurementExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100DeviceMeasurementException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        'error': json['error'] == null ? undefined : DeviceMeasurementErrorDtoFromJSON(json['error']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100DeviceMeasurementExceptionToJSON(value?: Omit<Ptw100DeviceMeasurementException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        'error': DeviceMeasurementErrorDtoToJSON(value['error']),
        '$type': value['$type'],
    });
}

